import {
  calculateDueDateDays,
  sortRequestsBySerialNumber,
} from '../../../../utils/informationManager';

/**
 * Enrich request rows with computed fields used by the table and filters.
 * @param {Array} list
 * @returns {Array}
 */
export function enrichRequestList(list = []) {
  list.forEach((item) => {
    const days = calculateDueDateDays(item.duedate);
    item.duedate_days = (days === '' || days === undefined || days === null) ? null : Number(days);
    const refs = (item.referenceChecklist || []).map((r) => r.ref).filter(Boolean);
    item.ref = refs.length > 0 ? refs : null;
    item.info_owner_name = (item.info_owner_detail || {}).name || '';
    item.created_by_name = (item.created_by_detail && item.created_by_detail.name)
      ? item.created_by_detail.name
      : '';
  });
  return list;
}

/**
 * Map project summary API fields to PipelineStatusChips summaryKey values.
 * @param {Object} summary
 * @returns {Object}
 */
export function buildRequestActiveSummary(summary = {}) {
  const inner = summary.summary || summary;
  return {
    count: inner.total || 0,
    pending: inner.requested || 0,
    pendingapproval: inner.pending || 0,
    approved: inner.closed || inner.approved || 0,
    cancelled: inner.cancelled || 0,
  };
}

/**
 * Apply stage filter to a request list.
 * @param {Array} list
 * @param {number|null} stage
 * @returns {Array}
 */
export function filterRequestsByStage(list = [], stage = null) {
  if (stage === null || stage === undefined) return list;
  return list.filter((item) => item.stage === stage);
}

/**
 * Clone, enrich, and sort request list for display/filtering (sno ascending).
 * @param {Array} source
 * @returns {Array}
 */
export function prepareRequestList(source = []) {
  const cloned = JSON.parse(JSON.stringify(source));
  return sortRequestsBySerialNumber(enrichRequestList(cloned));
}
